<template>
  <v-container class="pb-10">
    <h4 class="text-center mb-4">Zadaj typ upratania</h4>
    <v-row
      v-if="$vuetify.breakpoint.smAndUp"
      justify="center"
    >
      <v-btn-toggle v-model="cleaningType" @change="$emit('change', cleaningType)">
        <v-btn
          v-for="type in cleaningTypes"
          active-class="darken-4 no-border"
          class="ml-1"
          color="accent darken-1"
          :disabled="checkIfDisable(type)"
          :key="type"
          large
          :value="type"
        >
          {{ type }}
        </v-btn>
      </v-btn-toggle>
    </v-row>

    <v-row
      class="my-1"
      v-else
      justify="center"
      v-for="type in cleaningTypes"
      :key="type"
    >
      <v-btn-toggle v-model="cleaningType" @change="$emit('change', cleaningType)">
        <v-btn
          :width="$vuetify.breakpoint.smAndDown ? 250 : 0"
          :disabled="checkIfDisable(type)"
          class="white--text"
          color="accent darken-1"
          large
          :value="type"
        >
          {{ type }}
        </v-btn>
      </v-btn-toggle>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "CleaningType",
    props: [
      'time'
    ],
    data: () => ({
        cleaningTypes: [
            'Izba',
            'Kúpeľňa',
            'Izba a kúpeľňa'
        ],
        cleaningType: null
    }),
    methods: {
      checkIfDisable(cleaningType){
        return this.cleaningType === cleaningType
      }
    }
  }
</script>